import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import { LoginResponse } from '../login/Login';
import LoginActions from '../login/redux/actions';
import { UserState } from '../login/redux/types';
import MessageActions from '../message/redux/actions';

const SocailLoginRes: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const action = searchParams.get('action');
    const error = searchParams.get('error');

    useEffect(() => {
        if (token) {
            Apis.getSocialLoginResponse(token)
                .then((res) => {
                    const response: LoginResponse = res.data;
                    const { jwtToken, user } = response;

                    const userData: UserState = {
                        jwtToken,
                        user,
                        uuid: user?.uuid,
                    };
                    dispatch(LoginActions.loginReq(userData));
                })
                .catch((err) => {
                    dispatch(
                        MessageActions.showMessage({
                            error: true,
                            text: String(err),
                        }),
                    );
                    if (action === federatedActions.signup) {
                        navigate(HEADERMENU_PATH.signUp);
                    } else {
                        navigate(HEADERMENU_PATH.login, { replace: true });
                    }
                });
        } else if (error) {
            dispatch(
                MessageActions.showMessage({
                    error: true,
                    text: String(error),
                }),
            );
            if (action === federatedActions.signup) {
                navigate(HEADERMENU_PATH.signUp);
            } else {
                navigate(HEADERMENU_PATH.login);
            }
        } else {
            if (action === federatedActions.signup) {
                navigate(HEADERMENU_PATH.signUp);
            } else {
                navigate(HEADERMENU_PATH.login);
            }
        }
    }, [token, dispatch, navigate, error, action]);

    return (
        <div className="flex justify-center items-center h-screen flex-col">
            <Spin size="large" />
            <p className="text-lg font-semibold mt-4">Please wait</p>
        </div>
    );
};

export default SocailLoginRes;

export const federatedActions = {
    login: 'Login',
    signup: 'Signup',
};
